<form #form="ngForm" ngClass={{formClass}} [formGroup]="firstFormGroup">

  <app-header-title title="Cobrança" subTitle="Insira as informações solicitadas, em seguida calcule a cobrança."
    classTitle="title__semibold__orange">
  </app-header-title>

  <section ngClass={{sectionFirstClass}}>

    <div ngClass={{divClass}}>
      <mat-label ngClass={{matLabelClass}}>Forma de Parcelamento</mat-label>
      <mat-form-field appearance="outline" ngClass={{matClass}}>
        <mat-select placeholder="Selecione" formControlName="parcelamentoPrimeiraParcela"
          [ngClass]="!habilitaAlteracao ? 'blockMask' : ''">
          <mat-option *ngFor="let item of listFormaParcelamento" [value]="item.value"
            (click)="selecionaFormaParcelamento(item.viewValue)">
            {{item.viewValue}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div ngClass={{divClass}}>
      <mat-label ngClass={{matLabelClass}}>Periodicidade</mat-label>
      <mat-form-field appearance="outline" ngClass={{matClass}}>
        <mat-select placeholder="Selecione" formControlName="periodiciade"
          [ngClass]="!habilitaAlteracao ? 'blockMask' : ''">
          <mat-option *ngFor="let item of listPeriodicidade" [value]="item.value"
            (click)="habilitaEfetivarAlteracoes(item.value)">
            {{item.viewValue}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="firstFormGroup.controls.periodiciade.hasError('required')">
          <strong>Campo obrigatório</strong>
        </mat-error>
      </mat-form-field>
    </div>

    <div ngClass={{divClass}}>
      <mat-label ngClass={{matLabelClass}}>Forma de Pagamento</mat-label>
      <mat-form-field appearance="outline" ngClass={{matClass}}>
        <mat-select placeholder="Selecione" formControlName="formaPagamento"
          [ngClass]="!habilitaAlteracao ? 'blockMask' : ''">
          <mat-option *ngFor="let item of listFormaPagamento" [value]="item.value"
            (click)="alteraFormaPagamento(item.value)">
            {{item.viewValue}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div ngClass={{divClass}}>
      <mat-label ngClass={{matLabelClass}}>Data do 1º Vencimento</mat-label>
      <mat-form-field appearance="outline" ngClass={{matClass}}>
        <input matInput type="date" placeholder="dd/mm/yy" min="01-01-1960"
          [ngClass]="!habilitaAlteracao ? 'blockMask' : ''" formControlName="dataPrimeiroVencimento"
          [max]="maxInitialDate" [min]="minInitialDate" (change)="verificaDataVencimento()">
      </mat-form-field>
    </div>

    <div ngClass={{divButton}} *ngIf="!visualizar">
      <button mat-raised-button id="botao-efetivar-alteracoes" type="button" ngClass={{buttonClass}} [disabled]="!habilitaAlteracaoBotao"
        (click)="alterarPropostaI4pro()">EFETIVAR ALTERAÇÕES</button>
    </div>

  </section>

  <section ngClass={{sectionFirstClass}} *ngIf="liberaFormaParcelamento">

    <div ngClass={{divClass}}>
      <mat-label ngClass={{matLabelClass}}>Forma de Pagamento Demais Parcelas <mat-label
          class="mandatory">*</mat-label></mat-label>
      <mat-form-field appearance="outline" ngClass={{matClass}}>
        <mat-select placeholder="Selecione" formControlName="parcelamentoDemaisParcelas"
          [ngClass]="!habilitaAlteracao ? 'blockMask' : ''">
          <mat-option *ngFor="let item of listFormaPagamento" [value]="item.value">
            {{item.viewValue}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="firstFormGroup.controls.parcelamentoDemaisParcelas.hasError('required')">
          Forma de Pagamento Demais Parcelas é <strong>obrigatório</strong>
        </mat-error>
      </mat-form-field>
    </div>

    <div ngClass={{divClass}}>
      <mat-label ngClass={{matLabelClass}}>Dia do vencimento demais parcelas <mat-label
          class="mandatory">*</mat-label></mat-label>
      <mat-form-field appearance="outline" ngClass={{matClass}}>
        <input matInput maxlength="2" min="1" max="31" [ngClass]="!habilitaAlteracao ? 'blockMask' : ''"
          placeholder="Informe o dia" mask="00" formControlName="diaVencimentoDemaisParcelas"
          (change)="habilitaEfetivarAlteracoes(true)">
        <mat-error *ngIf="firstFormGroup.controls.diaVencimentoDemaisParcelas.hasError('required')">
          Dia do vencimento demais parcelas é <strong>obrigatório</strong>
        </mat-error>
      </mat-form-field>
    </div>

  </section>

</form>